/**
 * AppQueryTanstack bond setup
 *
 * Wires @molecule/app-query-tanstack to @molecule/app-query: the one document
 * cache the catalog pages seed from the prerendered JSON island, warm on
 * hover, and read synchronously on navigation.
 */

import { setProvider } from '@molecule/app-query'
import { provider } from '@molecule/app-query-tanstack'

export function setupAppQueryTanstack(): void {
  setProvider(provider)
}
